function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M6.446 21.915c-.73 0-1.13-.18-1.34-.3-.3-.18-.85-.62-1.34-1.93a22.35 22.35 0 01-1.27-7.67v-.01c.02-3.02.49-5.59 1.27-7.69.51-1.3 1.04-1.76 1.34-1.93.21-.13.61-.3 1.33-.3.28 0 .6.03.98.09 2.19.36 4.6 1.23 7.2 2.72a21.81 21.81 0 015.92 4.96c.87 1.1.97 1.8.97 2.14 0 .35-.1 1.05-.97 2.14a21.8 21.8 0 01-5.92 4.96h-.01a21.5 21.5 0 01-7.19 2.73c-.38.06-.7.08-.97.08",
  fill: "#ff6900",
  fillRule: "evenodd",
  stroke: "#000"
});

function SvgLoading(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default SvgLoading;